import React from 'react';
import isPromise from 'is-promise';
import { NotificationManager } from 'choerodon-ui/shared';
import { NotificationPlacement } from 'choerodon-ui/shared/notification-manager';
import Icon from '../icon';
import { newNotificationInstance } from './Notification';
import { getPrefixCls } from '../configure/utils';
export { NotificationPlacement };
const { config } = NotificationManager;
function setNotificationConfig(options) {
    const { duration, placement, bottom, top, getContainer, maxCount, foldCount, icons } = options;
    if (duration !== undefined) {
        config.duration = duration;
    }
    if (placement !== undefined) {
        config.placement = placement;
    }
    if (bottom !== undefined) {
        config.bottom = bottom;
    }
    if (top !== undefined) {
        config.top = top;
    }
    if (getContainer !== undefined) {
        config.getContainer = getContainer;
    }
    if (maxCount !== undefined) {
        config.maxCount = maxCount;
    }
    if (foldCount !== undefined) {
        config.foldCount = foldCount;
    }
    if (icons !== undefined) {
        config.icons = {
            ...config.icons,
            ...icons,
        };
    }
}
function getPlacementStyle(placement) {
    let style;
    switch (placement) {
        case 'topLeft':
            style = {
                left: 0,
                top: config.top,
                bottom: 'auto',
            };
            break;
        case 'topRight':
            style = {
                right: 0,
                top: config.top,
                bottom: 'auto',
            };
            break;
        case 'bottomLeft':
            style = {
                left: 0,
                top: 'auto',
                bottom: config.bottom,
            };
            break;
        default:
            style = {
                right: 0,
                top: 'auto',
                bottom: config.bottom,
            };
            break;
    }
    return style;
}
function getNotificationInstance(prefixCls, placement, callback) {
    const cacheKey = `${prefixCls}-${placement}`;
    const instance = NotificationManager.instances.get(cacheKey);
    if (instance) {
        if (isPromise(instance)) {
            instance.then(callback);
        }
        else {
            callback(instance);
        }
        return;
    }
    const { config } = NotificationManager;
    NotificationManager.instances.set(cacheKey, new Promise((resolve) => {
        newNotificationInstance({
            prefixCls,
            className: cacheKey,
            style: getPlacementStyle(placement),
            getContainer: config.getContainer,
            maxCount: config.maxCount,
            foldCount: config.foldCount,
        }, (notification) => {
            resolve(notification);
            NotificationManager.instances.set(cacheKey, notification);
            callback(notification);
        });
    }));
}
function notice(args) {
    const outerPrefixCls = getPrefixCls('notification', args.prefixCls);
    const prefixCls = `${outerPrefixCls}-notice`;
    const duration = args.duration === undefined ? config.duration : args.duration;
    let iconNode = null;
    if (args.icon) {
        iconNode = React.createElement("span", { className: `${prefixCls}-icon` }, args.icon);
    }
    else if (args.type) {
        const iconType = config.icons[args.type];
        iconNode = (React.createElement(Icon, { className: `${prefixCls}-icon ${prefixCls}-icon-${args.type}`, type: iconType }));
    }
    const autoMarginTag = !args.description && iconNode ? (React.createElement("span", { className: `${prefixCls}-message-single-line-auto-margin` })) : null;
    getNotificationInstance(outerPrefixCls, args.placement || config.placement, (notification) => {
        notification.notice({
            children: (React.createElement("div", { className: iconNode ? `${prefixCls}-with-icon` : '' },
                iconNode,
                React.createElement("div", { className: `${prefixCls}-message` },
                    autoMarginTag,
                    args.message),
                args.description ? React.createElement("div", { className: `${prefixCls}-description` }, args.description) : null,
                args.btn ? React.createElement("span", { className: `${prefixCls}-btn` }, args.btn) : null)),
            duration,
            closable: true,
            onClose: args.onClose,
            key: args.key,
            style: args.style || {},
            className: args.className,
        });
    });
}
const api = {
    open: notice,
    close(key) {
        NotificationManager.remove(key);
    },
    config: setNotificationConfig,
    destroy() {
        NotificationManager.clear();
    },
};
['success', 'info', 'warning', 'error'].forEach(type => {
    api[type] = (args) => api.open({
        ...args,
        type,
    });
});
api.warn = api.warning;
export default api;
